import { PayResponseData } from 'store/pay/types';

// SOSHA CONSTANTS
export const SOSHA_PILOT_PARTNERS = ['mx', 'dt', 'pd'];
export const SOSHA_CUSTOM_PARTNERS = ['bb'];
export const SOSHA_IFRAME_SRC =
  'https://app.sosha.ai/toolkit/986db138-b9d4-458f-b2fa-ba46aedb5c86?embedded=true&embedHeight=632&sliderEnabled=&showArrows=&iconsColor=%23000000&postBgColor=%23FFFFFF&postTextColor=%23000000&analyticsEnabled=';
export const SOSHA_CUSTOM_PARTNERS_IFRAME_SRC =
  'https://app.sosha.ai/toolkit/0ecb8f48-dfad-488e-91af-41eb1a132f94?embedded=true&embedHeight=632&sliderEnabled=&showArrows=&iconsColor=%23000000&postBgColor=%23FFFFFF&postTextColor=%23000000&analyticsEnabled=';

export const getIsDonationPending = (payment: PayResponseData) => {
  const { line_items: lineItems } = payment;
  return lineItems.some(
    item =>
      item.status === 'exception_during_authorization' ||
      item.status === 'authorization_awaiting_manual_review'
  );
};

export const canShowSosha = (isPaymentPending: boolean, urlPartner?: string) =>
  urlPartner &&
  (SOSHA_CUSTOM_PARTNERS.includes(urlPartner) || SOSHA_PILOT_PARTNERS.includes(urlPartner)) &&
  !isPaymentPending;
